<div class="row wrapper border-bottom white-bg page-heading" *ngIf="!public && dashboardId == null && showBanner">
    <div class="col-lg-8 col-md-6 col-xs-11">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item" *ngIf="siteUri == null">
            <a [routerLink]="['/dashboards']">Dashboards</a>
        </li>
        <li class="breadcrumb-item" *ngIf="siteUri != null && this.siteType">
            <a [routerLink]="['/site-type/' + this.siteType.siteTypeId]">{{this.dashboard.siteType}}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="dashboard">
            <a>{{dashboard.name}}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="dashboard && dashboard.publishedToPublic">
            <a>PUBLIC</a>
        </li>
        <li class="breadcrumb-item" *ngIf="dashboard && dashboard.periodSelect && dashboard.periodSelect.length > 0">
            <div class="btn-group form-group-sm float-sm-right" dropdown *ngIf="dashboard && dashboard.periodSelect && activePeriod">
                <a id="button-basic" dropdownToggle class="link" aria-controls="dropdown-basic">
                {{activePeriod.name}} 
                    <i class="fa fa-sort-asc"></i>
                </a>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                    <li role="menuitem" *ngFor="let period of dashboard.periodSelect"><a class="dropdown-item" (click)="changePeriod(period)">{{period.name}}</a></li>
                </ul>
            </div>
        </li>
      </ol>
    </div>
    <div class="col-md-1 float-right">
        <div class="admin-customer-select">
            <button *ngIf="dashboard && !dashboard.isFavourite" (click)="makeFavourite()" class="btn btn-outline-default btn-sm"><i class="bi bi-star"></i></button>
        </div>
    </div>
    <div class="col-lg-3 col-md-5 d-none d-md-block">
        <span class="signalr-status" *ngIf="dashboard && dashboard.liveData && connection" (click)="app.enableDebug = !app.enableDebug">
            <container-element [ngSwitch]="connection.state">
                <some-element *ngSwitchCase="'Connected'"><span class="badge bg-success">Online</span></some-element>             
                <some-element *ngSwitchCase="'Disconnected'"><span class="badge bg-danger">Offline</span></some-element>             
                <some-element *ngSwitchDefault><span class="badge bg-secondary">{{connection.state}}</span></some-element>
             </container-element>
        </span>
        <ul class="list-group clear-list m-t dashboard-stats" *ngIf="dashboard != null">
            <li *ngIf="!dashboard.publishedToPublic"><b>Created: </b>{{dashboard.createdBy}} ({{dashboard.createdDate | date:'shortDate'}})</li> 
            <li><b>Updated: </b>{{dashboard.updatedBy}} ({{dashboard.updatedDate | date:'shortDate'}})</li> 
            <li *ngIf="dashboard.publishedToPublic"><b>Published : </b>{{dashboard.publishedToPublicBy}} ({{dashboard.updatedDate | date:'shortDate'}})</li>
        </ul>
    </div>
</div>
  
<div class="app-theme-panel" [ngClass]="{'active':rightSidebar}" *ngIf="dashboard && showEditor && authService.isAuthenticated() && authService.isDashboardEditor()">
    <div class="app-theme-panel-container">
        <a (click)="toggleSideMenu()" data-toggle="theme-panel-expand" class="app-theme-toggle-btn"><i class="fa fa-cogs"></i></a>
        <div class="app-theme-panel-content">
            <div class="small fw-bold text mb-1">
                <span class="flex-grow-1">
                    <b>Dashboard Editor</b>
                </span>
                <button *ngIf="!isDashboardNew" style="float:right;" class="btn btn-outline-default btn-sm delete" type="submit" (click)="deleteDashboard()">
                    <i class="bi bi-trash"></i>
                </button>
            </div>
            <br/>
            <div class="card mb-3">
                <div class="card-body p-2">
                    
                        <div class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" id="editWidgetSwitch" [(ngModel)]="isEditEnabled" (change)="resizeWidgets()">
                            <label class="form-check-label" for="editWidgetSwitch">Widget Editing</label>
                        </div>

                        <button class="btn btn-block btn-outline-theme btn-sm mt-3" type="submit" (click)="dashboardSettings.show();showDashboardSettings();">Edit Parameters</button>
                       
                </div>           
                <div class="card-arrow">
                    <div class="card-arrow-top-left"></div>
                    <div class="card-arrow-top-right"></div>
                    <div class="card-arrow-bottom-left"></div>
                    <div class="card-arrow-bottom-right"></div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body p-2">
                    <div class="form-group">
                        <label>Name</label>
                        <input type="text"
                            placeholder="Enter Name"
                            class="form-control input-sm"
                            [(ngModel)]="dashboard.name" required>
                    </div>
                    <div class="btn-group mt-2" *ngIf="isEditEnabled">
                        <button class="btn" [ngClass]="{'btn-outline-default': !dashboard.embedded }" (click)="setEmbedded(false)">Dynamic</button>
                        <button class="btn" [ngClass]="{'btn-default': dashboard.embedded }" (click)="setEmbedded(true)">Embed</button>
                    </div>
                    <div class="form-group" *ngIf="isEditEnabled && dashboard.embedded">
                        <label>Embed URL</label>
                        <input type="text"
                            placeholder="Embed URL"
                            class="form-control input-sm"
                            [(ngModel)]="dashboard.embedUrl" required>
                    </div>
                </div>           
                <div class="card-arrow">
                    <div class="card-arrow-top-left"></div>
                    <div class="card-arrow-top-right"></div>
                    <div class="card-arrow-bottom-left"></div>
                    <div class="card-arrow-bottom-right"></div>
                </div>
            </div>
            <div class="card mb-3" *ngIf="isEditEnabled && !dashboard.embedded">
                <div class="card-body p-2">
                    <!-- New Widget List -->
                    <div class="new-widgets" [sortablejs]="newWidgets" [sortablejsOptions]="sortableSourceOptions">
                        <div class="new-widget" *ngFor="let widget of newWidgets">
                            <div class="widget-item bg-green bg-opacity-30">
                                <div class="widget-edit-header">
                                    <span class="title">
                                        <div class="icon">
                                            <a>
                                                <i [ngClass]="widget?.type ? (widget.type | getWidgetType: widgetTypes).icon : 'fa fa-default'"></i>
                                            </a>
                                        </div>
                                        <span [innerHtml]="widget?.type ? (widget.type | getWidgetType: widgetTypes).name : 'Not Found'">
                                        </span>
                                        
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>           
                <div class="card-arrow">
                    <div class="card-arrow-top-left"></div>
                    <div class="card-arrow-top-right"></div>
                    <div class="card-arrow-bottom-left"></div>
                    <div class="card-arrow-bottom-right"></div>
                </div>
            </div>

            <div class="card mb-3">
                <div class="card-body p-2">
                    <button *ngIf="!isDashboardNew; else addDashboardBtn" title="Save to Dashboard" class="btn btn-block btn-outline-primary btn-sm" type="submit" (click)="saveDashboard()">Save</button>
                    <ng-template #addDashboardBtn>
                        <button class="btn btn-block btn-outline-primary btn-sm" type="submit" (click)="addDashboard()">Add</button>
                    </ng-template>
                </div>           
                <div class="card-arrow">
                    <div class="card-arrow-top-left"></div>
                    <div class="card-arrow-top-right"></div>
                    <div class="card-arrow-bottom-left"></div>
                    <div class="card-arrow-bottom-right"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Widget Editor -->
<div *ngIf="isModalShown" [config]="{ show: true }" (onHidden)="onHidden()" bsModal #dashboardModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">WIDGET EDITOR</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="hideModal()"></button>
        </div>
      <div class="modal-body">
        <app-widget-editor [widget]="editWidget" [dashboard]="dashboard" [siteUri]="siteUri"></app-widget-editor>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-bs-dismiss="modal" (click)="hideModal()">Close</button>
        <button type="button" class="btn btn-outline-theme" (click)="saveDashboard();hideModal();">Save Changes</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #dashboardSettings="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">DASHBOARD SETTINGS</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="dashboardSettings.hide()"></button>
        </div>
        <div class="modal-body" *ngIf="dashboard">
            <tabset>
                <tab [heading]="'General'">
                    <div class="row mt-3">
                        <div class="col-lg-7">
                            <div class="form-group input-group-sm mb-3">
                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="editWidgetSwitch" [(ngModel)]="dashboard.liveData">
                                    <label class="form-check-label" for="editWidgetSwitch">Live Data</label>
                                </div>
                            </div> 
                            <div class="form-group input-group-sm mb-2">
                                <label>Category
                                    <br>
                                    <small class="text-warning">Used to group dashboards based on a similar category.</small>
                                </label>
                                
                                <div class="input-group m-b">
                                    <input type="text" class="form-control" [(ngModel)]="dashboard.category">
                                </div>
                            </div> 
                            <div class="form-group input-group-sm mb-2">
                                <label>Site Type
                                    <br>
                                    <small class="text-warning">With a site type applied, a Dashboard will be applied as a template to any data set of that site type. It will no longer be available as a normal dashboard. You can use tag searches on widgets to match time series within a site.</small>
                                </label>
                                
                                <div class="input-group m-b">
                                    <select [(ngModel)]="dashboard.tagValue" class="form-control form-select" (change)="onSiteTypeChange()">
                                        <option value="">None</option>
                                        <option *ngFor="let siteType of siteTypes" [value]="siteType.siteTypeCode">{{siteType.siteTypeCode}}</option>
                                    </select>
                                </div>
                            </div>     
                            <div class="form-group input-group-sm mb-2">
                                <label>Time Zone</label>
                                <select class="form-control form-select" [(ngModel)]="dashboard.timeZone" (change)="onTimeZoneChange($event.target.value)">
                                    <option value="">-- SYSTEM DEFAULT --</option>
                                    <option *ngFor="let zone of timeZones" [value]="zone">{{zone}}</option>
                                </select>
                                <!--<ngx-dropdown-treeview 
                                    [config]="treeViewConfig"
                                    [items]="timeZones"
                                    (selectedChange)="onTimeZoneChange($event)">
                                </ngx-dropdown-treeview>-->
                            </div>      
               
                            <div class="form-group input-group-sm mb-2" *ngIf="!isDashboardNew && authService.isDashboardEditor()">
                                <label>Column Layout</label>
                                <br>
                                <div class="btn-group m-b">
                                    <button class="btn" [ngClass]="dashboard.layout == 'Standard' ? 'btn-primary' : 'btn-outline-default'" (click)="selectLayout('Standard')">Standard</button>
                                    <button class="btn" [ngClass]="dashboard.layout == 'Even' ? 'btn-primary' : 'btn-outline-default'" (click)="selectLayout('Even')">Even</button>
                                    <button class="btn" [ngClass]="dashboard.layout == 'Custom' ? 'btn-primary' : 'btn-outline-default'" (click)="selectLayout('Custom')">Custom</button>
                                </div>
                            </div>
                            <div *ngIf="dashboard.layout == 'Custom'">
                                <label>Column Widths (must sum to 12)</label>
                                <br>
                                <div class="input-group mb-3">
                                    <div class="row w-80">
                                    <!-- <span class="input-group-text">L</span>
                                        <input type="text" class="form-control" placeholder="Left" aria-label="Left"
                                            [(ngModel)]="dashboard.columns[0].widthPercentage">
                                        <span class="input-group-text">M</span>
                                        <input type="text" class="form-control" placeholder="Middle" aria-label="Middle"
                                            [(ngModel)]="dashboard.columns[1].widthPercentage">
                                        <span class="input-group-text">R</span>
                                        <input type="text" class="form-control" placeholder="Right" aria-label="Right"
                                            [(ngModel)]="dashboard.columns[2].widthPercentage"> -->
                                    <div class="col-4">
                                        <label for="column1" class="form-label">Left:</label>
                                        <select id="column1"  class="form-select" [(ngModel)]="dashboard.columns[0].width" name="col1" (ngModelChange)="updateColumnOptions()">
                                            <option *ngFor="let option of col1WidthOptions" [value]="option">{{ option }}</option>
                                        </select>
                                    </div>
                                
                                    <div class="col-4">
                                        <label for="column2" class="form-label">Mid:</label>
                                        <select id="column2"  class="form-select" [(ngModel)]="dashboard.columns[1].width" name="col2" (ngModelChange)="updateColumnOptions()">
                                            <option *ngFor="let option of col2WidthOptions" [value]="option">{{ option }}</option>
                                        </select>
                                    </div>
                                
                                    <div class="col-4">
                                        <label for="column3" class="form-label">Right:</label>
                                        <select id="column3" class="form-select" [(ngModel)]="dashboard.columns[2].width" name="col3" (ngModelChange)="updateColumnOptions()">
                                            <option *ngFor="let option of col3WidthOptions" [value]="option">{{ option }}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="form-group input-group-sm mb-2" *ngIf="!isDashboardNew && authService.isDashboardEditor()">
                                <label>Export Dashboard</label>
                                <div class="input-group m-b">
                                    <button class="btn btn-block btn-outline-default" type="submit" (click)="exportDashboard()">Save as JSON</button>       
                                </div>
                            </div>
                            <div class="form-group input-group-sm mb-2" *ngIf="!isDashboardNew && authService.isDashboardEditor()">
                                <label>Import Dashboard</label>
                                <div class="input-group m-b">
                                    <input type="file" class="form-control" id="file" (change)="importDashboard($event.target.files)">
                                </div>
                            </div>
                            <div class="form-group input-group-sm mb-2">
                                <label>Period</label>
                                <div class="input-group m-b">
                                    <app-time-period [(period)]="dashboard.period" [type]="'text'"></app-time-period>
                                </div>
                                <br>
                                <small class="text-warning">Specify multiple pre-defined time periods below that your dashboard will support.</small>
                            </div> 
                            <div class="form-group input-group-sm mb-2">
                                <table class="table">
                                    <tr>
                                        <th>Name</th><th>Period</th><th><a (click)="addPeriodSelect()"><i class="fa fa-plus"></i></a></th>
                                    </tr>
                                    <tr *ngIf="dashboard.periodSelect == null || dashboard.periodSelect.length == 0">
                                        <td colspan="3">No Period Selection Options Will Be Visible</td>
                                    </tr>
                                    <tr *ngFor="let period of dashboard.periodSelect">
                                        <td>
                                            <div class="input-group m-b">
                                                <input type="text" [(ngModel)]="period.name">
                                            </div>
                                        </td>
                                        <td>
                                            <app-time-period [(period)]="period.period" [type]="'text'"></app-time-period>
                                        </td>
                                        <td>
                                            <a (click)="removePeriodSelect(period)"><i class="fa fa-minus"></i></a>
                                        </td>
                                    </tr>
                                </table>
                            </div> 
                                         
                        </div>
                    </div>
                </tab>
                <tab *ngIf="!isDashboardNew && dashboard && !dashboard.global && authService.isDashboardEditor()" [heading]="'Publications'">
                    <div class="row mt-3">
                        <div class="col-lg-3 ">
                            <!-- actions -->
                            <br/>
                            <div *ngIf="dashboard.tagValue">
                                <button *ngIf="!isDashboardNew && dashboard && !dashboard.global && authService.isAdmin()" class="btn btn-outline-danger btn-sm" type="submit" (click)="publishToGlobalDashboard()">Publish Global</button>
                                <button *ngIf="!isDashboardNew && dashboard && dashboard.global && authService.isAdmin()" class="btn btn-outline-danger btn-sm" type="submit" (click)="unPublishToGlobalDashboard()">Un Publish Global</button>
                                <br/>
                                <small class="text-warning">Publishing Globally will make the dashboard visible to ALL clients within the system. Only possible with dashboards assigned to a site type.</small>
                            </div>
                            <br/>
                            <button *ngIf="!isDashboardNew && dashboard && !dashboard.publishedToPublic" class="btn btn-outline-danger btn-sm" type="submit" (click)="publishToPublicDashboard()">Publish Public</button>
                            <button *ngIf="!isDashboardNew && dashboard && dashboard.publishedToPublic" class="btn btn-outline-danger btn-sm" type="submit" (click)="unPublishToPublicDashboard()">Un Publish Public</button>
                            <br/>
                            <div class="form-group" *ngIf="!isDashboardNew && dashboard && dashboard.publishedToPublic">
                                <label>Publish Code</label>
                                <textarea type="text"  rows="3"
                                    class="form-control input-sm"
                                    [(ngModel)]="publishCode" readonly></textarea>
                            </div>               
                            <div class="form-group" *ngIf="!isDashboardNew && dashboard && dashboard.publishedToPublic">
                                <label>Public URL</label>
                                <textarea type="text" rows="3"
                                    class="form-control input-sm"
                                    [(ngModel)]="publicUrl" readonly></textarea>
                            </div> 
                        </div>

                        <div class="col-lg-9">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Email</th>
                                        <th>Valid Until</th>
                                        <th>URL</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let p of publications">
                                        <td>{{p.emailAddress}}</td>
                                        <td>{{p.linkValidToo | relativeDate}}</td>
                                        <td><input type="text" class="form-control form-control-sm" [value]="generatePublishedUrl(p.publishedIdentifier)"></td>
                                        <td>
                                            <a class="btn btn-outline-danger ml-2" (click)="deletePublication(p)"><i class="fa fa-trash"></i></a>
                                        </td>
                                    </tr>
                                    <tr *ngIf="publicationsLoading">
                                        <td colspan="4">
                                            Loading...
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input [(ngModel)]="newPublication.emailAddress" type="email" class="form-control form-control-sm"></td>
                                        <td><input [(ngModel)]="newPublication.linkValidToo" type="date" class="form-control form-control-sm"></td>
                                        <td></td>
                                        <td><a class="btn btn-outline-default ml-2" [disabled]="newPublication.emailAddress == null || newPublication.linkValidToo == null" (click)="addPublication()"><i class="fa fa-plus"></i></a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                    </div>  
                </tab>
            </tabset>        
        </div>
        <div class="modal-footer">
            <!-- <button *ngIf="!isDashboardNew && dashboard && !dashboard.archived" class="btn btn-outline-danger btn-sm mr-1" type="submit" (click)="archiveDashboard();dashboardSettings.hide()">Archive Dashboard</button> -->
            <small  *ngIf="!isDashboardNew && dashboard && dashboard.archived" class="text-danger fst-italic text-sm">This dashboard is soft deleted and can only be seen by administrators.</small>
            <button *ngIf="!isDashboardNew && dashboard && dashboard.archived" class="btn btn-outline-danger btn-sm mr-1" type="submit" (click)="unArchiveDashboard();dashboardSettings.hide()">Un-Delete Dashboard</button>
            
            <button (click)="dashboardSettings.hide()" class="btn btn-white">Close</button>
            <button (click)="saveDashboard();dashboardSettings.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
</div>

<div *ngIf="loading" class="animate__animated animate__fadeIn mt-3" >
    <div class="spinner-border text-success"></div>
</div>

<!-- Dashboard Display -->
<div>
    <div *ngIf="!loading && dashboard && !dashboard.embedded && !permissionDenied" [ngClass]="{'amimated__zoomIn': dashboard.showBanner}" class="animate__animated">    
        <div class="row dashboard-row" [ngClass]="{ 'editing': isEditEnabled }">
            <div *ngFor="let column of dashboard.columns| dashboardFilter: isEditEnabled; let col = index " class="column {{getColumnClass(column)}}" [ngClass]="{ 'editing': isEditEnabled }">
                <div *ngIf="isEditEnabled">
                    <h1 *ngIf="col == 0">Left/Top</h1>
                    <h1 *ngIf="col == 1">Centre/Middle</h1>
                    <h1 *ngIf="col == 2">Right/Bottom</h1>
                </div>
                <div class="row" [ngClass]="{'column-editing no-gutters':isEditEnabled}" [sortablejs]="column.widgets" [sortablejsOptions]="sortableDisplayOptions">
                    <div *ngFor="let widget of column.widgets | visiblewidget : isEditEnabled" class="widget-col" [ngClass]="(widget | getWidgetSize: dashboard: column)">
                        <div class="dashboard-widget" [ngClass]="{'editing':isEditEnabled}">
                            
                            <div class="card widget-edit-header bg-white bg-opacity-30" *ngIf="isEditEnabled">
                                <div class="card-header">
                                    <div class="d-flex fw-bold small mb-3  text-truncate text-uppercase">
                                        <span class="flex-grow-1"></span>
                                        <span>
                                            <a class="btn btn-outline-danger btn-sm mr-2" (click)="removeWidget(column, widget)">
                                                <i class="bi bi-trash"></i>
                                            </a>                                
                                            <!--<a class="btn btn-outline-default btn-sm" (click)="copyWidgetSettings($event, widget)" title="Copy widget to clipboard">
                                                <i class="bi bi-clipboard-plus"></i>
                                            </a>-->                                
                                            <a class="btn btn-outline-default btn-sm mr-2" (click)="duplicateWidgetSettings($event, widget)" title="Duplicate Widget">
                                                <i class="bi bi-clipboard-plus"></i>
                                            </a>
                                            <a class="btn btn-outline-default btn-sm" (click)="editWidgetSettings(widget)">
                                                <i class="bi bi-wrench"></i>
                                            </a>
                                        </span>
                                    </div>
                                    <span>
                                        {{ widget?.type ? removeHtml((widget.type | getWidgetType: widgetTypes)?.name) : "Not Found"}}
                                    </span>
                                </div>
                            </div>

                            <div class="widget-body">
                                <app-widget [dashboard]="dashboard"  [delayLoad]="delayLoad" [fullScreen]="false" [widget]="widget" [class]="'widget-height' + widget.height" [uri]="uri" [siteUri]="siteUri" (dashboardSelected)="dashboardSelected($event)" (widgetSelected)="widgetSelected($event)"></app-widget>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading && permissionDenied" class="animate__animated animate__zoomIn">
        <div class="bg-inverse bg-opacity-10 p-5 rounded-3">
            <h1 class="display-4">Access Denied</h1>
            <p class="lead">The link you are opening cannot be found or has not been published.</p>
            <hr class="my-4">
            <p class="lead">Please check the link or check with the person who shared the link that it is the latest version.</p>
        </div>
    </div>
    <div *ngIf="!loading && notFound" class="animate__animated animate__zoomIn">
        <div class="bg-inverse bg-opacity-10 p-5 rounded-3">
            <h1 class="display-4">Dashboard Not Found</h1>
            <p class="lead">The link you are opening cannot be found or you do not have permission to view this dashboard</p>
            <hr class="my-4">
            <p class="lead">Try opening the dashboard again from the dashboard page</p>
            <a class="btn btn btn-primary btn-lg" [routerLink]="'/dashboards'" role="button">Dashboards</a>
        </div>
    </div>
</div>

<div *ngIf="dashboard && dashboard.embedded" [ngClass]="{'amimated__zoomIn': dashboard.showBanner}" class="wrapper sidebar animate__animated" >
    <iframe *ngIf="embedUrl" class="iframe" [src]="embedUrl" width="100%" ></iframe>
</div>

<!-- Modal -->
<div class="modal fade modal-fullscreen" bsModal #dashboardModal="bs-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog dashboard-modal-dialog" *ngIf="selectedDashboard">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">{{selectedDashboard.displayName}}</h4>
                <button type="button" class="close pull-right btn btn-outline" aria-label="Close" (click)="dashboardModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="selectedDashboard.dashboardId">
                <app-dashboard #embeddedDashboard [dashboardId]="selectedDashboard.dashboardId" [showEditor]="false" [showBanner]="false"></app-dashboard>
            </div>
        </div>
    </div>
</div>

<div class="modal fade modal-fullscreen" bsModal #widgetModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name" (onHide)="fullWidget=null">
    <div class="modal-dialog dashboard-modal-dialog" *ngIf="fullWidget">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">{{fullWidget.name}}</h4>
                <button type="button" class="close pull-right btn btn-outline" aria-label="Close" (click)="widgetModal.hide();fullWidget=null;">
                    <span aria-hidden="true"><i class="bi bi-x"></i></span>
                </button>
            </div>
            <div class="modal-body">
                <app-widget *ngIf="fullWidget" #embeddedWidget [fullScreen]="true" [dashboard]="dashboard" [widget]="fullWidget?.widget" [uri]="uri" (dashboardSelected)="dashboardSelected($event)"></app-widget>
            </div>
        </div>
    </div>
</div>
